<template>
  <div class="viewing-as">
    <h4 class="header">
      VIEWING AS
    </h4>
    <p
      class="data"
      data-cy="viewing-as-user-name"
    >
      <b>{{ userName }}</b>{{ roleType }}
    </p>
    <p
      v-if="companyName"
      data-cy="viewing-as-company-name"
      class="data"
    >
      {{ companyName }}
    </p>
    <p
      v-if="activeOrg != null && (viewAsCompany!= null || !snAdmin)"
      class="data"
      data-cy="sr-active-org"
    >
      {{ activeOrg.value }}
    </p>
    <p
      v-if="viewAsCompany != null|| !snAdmin"
      class="data"
    >
      {{ isStaging ? 'Staging' : 'Production' }}
    </p>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import _ from 'lodash'
import { companyOrgs } from '../graphql/signing_room_queries.gql'

export default {
  name: 'ViewingAs',
  data () {
    return {
      orgOptions: [],
      activeOrg: null
    }
  },
  computed: {
    ...mapGetters(['user', 'isStaging', 'orgId', 'viewAsCompany']),
    userName () {
      if (this.user) {
        return this.user.firstName + ' ' + this.user.lastName
      }
      return ''
    },
    roleType () {
      if (this.user.accountType) {
        const roleDisplay = _.capitalize(this.user.accountType.replaceAll('_', ' '))
        return ` - ${roleDisplay}`
      }
      return ''
    },
    companyName () {
      if (!this.user) {
        return null
      } else if (this.user.isSnAdmin && this.viewAsCompany) {
        return this.viewAsCompany.name
      } else if (this.user.company) {
        return this.user.company.name
      }

      return null
    },
    snAdmin () {
      return this.user != null && this.user.accountType === 'admin'
    },
    timeZone () {
      if (!this.user) {
        return null
      } else if (this.user.timezone) {
        return this.user.timezone
      }
      return null
    }
  },
  watch: {
    orgId () {
      this.getOrgs()
    },
    viewAsCompany () {
      this.getOrgs()
    }
  },
  created () {
    document.addEventListener('click', this.clickAway)
    this.getOrgs()
  },
  methods: {
    getOrgs () {
      if (this.snAdmin && (!this.viewAsCompany || !this.viewAsCompany.guid)) {
        return null
      } else {
        this.$apollo.query({
          query: companyOrgs,
          variables: {
            companyGuid: this.viewAsCompany == null ? null : this.viewAsCompany.guid
          }
        }).then(({ data }) => {
          if (data.companyOrgs) {
            const orgs = data.companyOrgs

            this.orgOptions = orgs.map(org => {
              return { guid: org.guid, value: org.name, subtext: '', action: 'switch_org' }
            })
            this.activeOrg = this.orgOptions.find(opt => opt.guid === this.orgId)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Was a v-container, which contributed nothing here but its padding - its
   breakpoint max-widths never bind inside a 256px rail. The rule below used to
   target Vuetify's .container class. */
.viewing-as {
  padding: var(--spacing-8);

  /* Replaces the .footer-border element: a bare 1px rule bled edge-to-edge with
     -16px margins. As a border on this box it needs no negative margins and no
     !important. --color-border-tertiary is #E5E5E5 exactly, and is the same
     token .side-menu uses for its right edge. */
  border-top: 1px solid var(--color-border-tertiary, #E5E5E5);
}

/* #BFBFBF exactly, the same substitution the profile dropdown's section
   headings use. --color-text-secondary is the semantic token for de-emphasised
   text but is considerably darker. */
.header {
  color: var(--color-neutral-40, #BFBFBF);
}

.data {
  margin: 0 !important;
}

</style>
